import { render, staticRenderFns } from "./RegistroPersonal.vue?vue&type=template&id=60e7bf52&scoped=true"
import script from "./RegistroPersonal.vue?vue&type=script&lang=js"
export * from "./RegistroPersonal.vue?vue&type=script&lang=js"
import style0 from "./RegistroPersonal.vue?vue&type=style&index=0&id=60e7bf52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7bf52",
  null
  
)

export default component.exports